import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import Locales from 'ui-component/Locales';
// import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';


//analytics provider
import { LogRocketProvider } from 'contexts/LogRocketContext';

import LoginPopup from 'views/LoginPopup';
import ChunkReloadNotice from 'views/ChunkReloadNotice';

import { SnackbarProvider } from 'notistack';

import { PendingInputProvider } from 'contexts/PendingInputContext';
// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                {/* RTL layout */}
                {/* <RTLLayout> */}
                <Locales>
                    
                        <LogRocketProvider>
                            <PendingInputProvider>
                                <Routes />
                            </PendingInputProvider>
                            <Snackbar />
                            <SnackbarProvider
                                maxSnack={3}
                                anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                            />
                            <LoginPopup />
                            <ChunkReloadNotice />
                        </LogRocketProvider>
                    
                </Locales>
                {/* </RTLLayout> */}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
